module.exports = __webpack_public_path__ + "img/weight-a.49451f0b.png";